"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Utilities for field contexts
 */
class ContextUtils {
}
/**
 * Returns whether field context is within enabled contexts
 *
 * @param enabledContexts enabled contexts
 * @param fieldContexts field contexts
 * @returns whether field context is within enabled contexts
 */
ContextUtils.isEnabledContext = (enabledContexts, fieldContexts) => {
    if (enabledContexts === undefined || fieldContexts === undefined) {
        return true;
    }
    if (enabledContexts.length === 0 || fieldContexts.length === 0) {
        return true;
    }
    return !!enabledContexts.find(context => fieldContexts.includes(context));
};
exports.default = ContextUtils;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGV4dC11dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jb250ZXh0LXV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUE7O0dBRUc7QUFDSCxNQUFxQixZQUFZOztBQUUvQjs7Ozs7O0dBTUc7QUFDVyw2QkFBZ0IsR0FBRyxDQUFDLGVBQTBCLEVBQUUsYUFBd0IsRUFBRSxFQUFFO0lBQ3hGLElBQUksZUFBZSxLQUFLLFNBQVMsSUFBSSxhQUFhLEtBQUssU0FBUyxFQUFFO1FBQ2hFLE9BQU8sSUFBSSxDQUFDO0tBQ2I7SUFFRCxJQUFJLGVBQWUsQ0FBQyxNQUFNLEtBQUssQ0FBQyxJQUFJLGFBQWEsQ0FBQyxNQUFNLEtBQUssQ0FBQyxFQUFFO1FBQzlELE9BQU8sSUFBSSxDQUFDO0tBQ2I7SUFFRCxPQUFPLENBQUMsQ0FBQyxlQUFlLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUMsYUFBYSxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO0FBQzVFLENBQUMsQ0FBQTtBQW5CSCwrQkFvQkMifQ==